var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var TarefasCacheService = /** @class */ (function () {
                /** @ngInject **/
                function TarefasCacheService($state, authorizationService, authService, $timeout, $rootScope) {
                    var _this = this;
                    this.$state = $state;
                    this.authorizationService = authorizationService;
                    this.authService = authService;
                    this.$timeout = $timeout;
                    this.tasks = [];
                    this.loaded = false;
                    $rootScope.$on("$stateChangeSuccess", function (event, toState) {
                        if (toState.name === "app.login") {
                            _this.clear();
                        }
                    });
                    $rootScope.$on("task:created", function (event, notification) {
                        _this.onTaskCreated(notification);
                    });
                    $rootScope.$on("task:assigned", function (event, notification) {
                        _this.onTaskAssigned(notification);
                    });
                    $rootScope.$on("task:tagged", function (event, notification) {
                        _this.onTaskTagged(notification);
                    });
                    $rootScope.$on("task:renamed", function (event, notification) {
                        _this.onTaskRenamed(notification);
                    });
                    angular.forEach(["task:completed", "task:canceled", "task:removed", "task:hidden"], function (removeEvent) {
                        $rootScope.$on(removeEvent, function (event, notification) {
                            _this.onTaskRemoved(notification);
                        });
                    });
                    angular.forEach({ assigneeGroup: "task:assigned-group", priority: "task:prioritized",
                        notes: "task:annotated", draft: "task:saved", extraInfo: "task:informed",
                        restricted: "task:restricted" }, function (eventName, property) {
                        $rootScope.$on(eventName, function (event, notification) {
                            _this.onTaskPropertyModified(notification, property);
                        });
                    });
                }
                TarefasCacheService.prototype.register = function (tasks) {
                    var _a;
                    this.tasks.splice(0, this.tasks.length);
                    (_a = this.tasks).push.apply(_a, tasks);
                    this.loaded = true;
                };
                TarefasCacheService.prototype.get = function () {
                    return this.tasks;
                };
                TarefasCacheService.prototype.isLoaded = function () {
                    return this.loaded;
                };
                TarefasCacheService.prototype.clear = function () {
                    this.tasks.splice(0, this.tasks.length);
                    this.loaded = false;
                };
                TarefasCacheService.prototype.remove = function (task) {
                    var tasksRemoved = _.remove(this.tasks, function (t) { return t.id === task.id && t.context === task.context; });
                    if (tasksRemoved.length > 0) {
                        this.executeCallback(this.taskCallbackFn);
                    }
                };
                TarefasCacheService.prototype.registerTaskCreatedCallbackFn = function (cb) {
                    this.taskCreatedCallbackFn = cb;
                };
                TarefasCacheService.prototype.registerTaskAssignedCallbackFn = function (cb) {
                    this.taskAssignedCallbackFn = cb;
                };
                TarefasCacheService.prototype.registerTaskTaggedCallbackFn = function (cb) {
                    this.taskTaggedCallbackFn = cb;
                };
                TarefasCacheService.prototype.registerTaskCallbackFn = function (cb) {
                    this.taskCallbackFn = cb;
                };
                TarefasCacheService.prototype.unregisterCallbacks = function () {
                    this.taskAssignedCallbackFn = undefined;
                    this.taskCreatedCallbackFn = undefined;
                    this.taskTaggedCallbackFn = undefined;
                    this.taskCallbackFn = undefined;
                };
                TarefasCacheService.prototype.onTaskCreated = function (notification) {
                    var _this = this;
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (!taskFound) {
                        this.authorizationService.findPermission(task.command, task.context, false)
                            .then(function (permission) { return _this.loadCreatedTask(task, (!!permission ? false : true)); })
                            .catch(function () { return _this.loadCreatedTask(task, true); });
                        this.executeCallback(this.taskCreatedCallbackFn, task);
                    }
                };
                TarefasCacheService.prototype.onTaskAssigned = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound.assignee = task.assignee;
                        taskFound.claimDate = task.claimDate;
                        taskFound.assignor = task.assignor;
                        taskFound.selfAssigned = taskFound.assignee === this.authService.getUserLogin();
                        this.executeCallback(this.taskAssignedCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskAssigned(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskTagged = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound.etags = notification.content.tags;
                        this.executeCallback(this.taskTaggedCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskTagged(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskRenamed = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound.title = task.title;
                        if (!!task.searchableId && task.searchableId.length > 0) {
                            taskFound.searchableId = task.searchableId;
                        }
                        if (!!task.informationId && task.informationId.length > 0) {
                            taskFound.informationId = task.informationId;
                        }
                        this.executeCallback(this.taskCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskRenamed(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskRemoved = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var tasksRemoved = _.remove(this.tasks, function (t) { return t.id === task.id && t.context === task.context; });
                    if (tasksRemoved.length > 0) {
                        this.executeCallback(this.taskCallbackFn);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskRemoved(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskPropertyModified = function (notification, property, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound[property] = task[property];
                        this.executeCallback(this.taskCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskPropertyModified(notification, property, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.loadCreatedTask = function (task, readOnly) {
                    task.readOnly = readOnly;
                    task.startDate = new Date(task.startDate).toISOString();
                    this.tasks.push(task);
                };
                TarefasCacheService.prototype.findTask = function (context, id) {
                    return this.tasks.find(function (task) { return task.id === id && task.context === context; });
                };
                TarefasCacheService.prototype.executeCallback = function (cb, task) {
                    if (!!cb && this.isTaskState()) {
                        cb(task);
                    }
                };
                TarefasCacheService.prototype.retry = function (eventFn, retries) {
                    if (retries <= TarefasCacheService.MAX_RETRIES) {
                        this.$timeout(function () {
                            retries++;
                            eventFn(retries);
                        }, TarefasCacheService.DELAY);
                    }
                };
                TarefasCacheService.prototype.isTaskState = function () {
                    return this.$state.current.name === "app.tarefas.minhas-tarefas";
                };
                TarefasCacheService.DELAY = 500;
                TarefasCacheService.MAX_RETRIES = 3;
                return TarefasCacheService;
            }());
            minhasTarefas.TarefasCacheService = TarefasCacheService;
            var SERVICE_NAME = "app.tarefas.minhas-tarefas.TarefasCacheService";
            angular
                .module("app.tarefas.minhas-tarefas")
                .service(SERVICE_NAME, TarefasCacheService);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));
